export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST'
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS'
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL'

export const ORDER_CREATE_RESET = 'ORDER_CREATE_RESET'

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST'
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS'
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL'

export const ORDER_PAY_REQUEST = 'ORDER_PAY_REQUEST'
export const ORDER_PAY_SUCCESS = 'ORDER_PAY_SUCCESS'
export const ORDER_PAY_FAIL = 'ORDER_PAY_FAIL'
export const ORDER_PAY_RESET = 'ORDER_PAY_RESET'

export const ORDER_LIST_MY_REQUEST = 'ORDER_LIST_MY_REQUEST'
export const ORDER_LIST_MY_SUCCESS = 'ORDER_LIST_MY_SUCCESS'
export const ORDER_LIST_MY_FAIL = 'ORDER_LIST_MY_FAIL'
export const ORDER_LIST_MY_RESET = 'ORDER_LIST_MY_RESET'


export const ORDER_LIST_REQUEST = 'ORDER_LIST_REQUEST'
export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS'
export const ORDER_LIST_FAIL = 'ORDER_LIST_FAIL'


export const ORDER_DELIVER_REQUEST = 'ORDER_DELIVER_REQUEST'
export const ORDER_DELIVER_SUCCESS = 'ORDER_DELIVER_SUCCESS'
export const ORDER_DELIVER_FAIL = 'ORDER_DELIVER_FAIL'
export const ORDER_DELIVER_RESET = 'ORDER_DELIVER_RESET'

export const STRIPE_PUBLISHABLE_KEY_REQUEST = 'STRIPE_PUBLISHABLE_KEY_REQUEST'
export const STRIPE_PUBLISHABLE_KEY_SUCCESS = 'STRIPE_PUBLISHABLE_KEY_SUCCESS'
export const STRIPE_PUBLISHABLE_KEY_FAIL = 'STRIPE_PUBLISHABLE_KEY_FAIL'

export const STRIPE_PAYMENT_INTENT_REQUEST = 'STRIPE_PAYMENT_INTENT_REQUEST'
export const STRIPE_PAYMENT_INTENT_SUCCESS = 'STRIPE_PAYMENT_INTENT_SUCCESS'
export const STRIPE_PAYMENT_INTENT_FAIL = 'STRIPE_PAYMENT_INTENT_FAIL'

export const SHIPPING_COST_REQUEST = 'SHIPPING_COST_REQUEST'
export const SHIPPING_COST_SUCCESS = 'SHIPPING_COST_SUCCESS'
export const SHIPPING_COST_FAIL = 'SHIPPING_COST_FAIL'

export const SHIPPING_COUNTRIES_REQUEST = 'SHIPPING_COUNTRIES_REQUEST'
export const SHIPPING_COUNTRIES_SUCCESS = 'SHIPPING_COUNTRIES_SUCCESS'
export const SHIPPING_COUNTRIES_FAIL = 'SHIPPING_COUNTRIES_FAIL'
